import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GET } from "../../services/axios.service";
import {
  SamplePartyProps,
  SampleItemProps,
  SampleProcessProps,
} from "../../types/sample";

export interface NewOrderState {
  parties: SamplePartyProps[];
  items: SampleItemProps[];
  processes: SampleProcessProps[];
  loading: boolean;
  error: string | null;
}

const initialState: NewOrderState = {
  parties: [],
  items: [],
  processes: [],
  loading: false,
  error: null,
};

export const fetchPartiesData = createAsyncThunk(
  "fetchPartiesDataForSample",
  async () => {
    let response: any;
    await GET(`/v1/worker/order-parties`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const fetchItemsData = createAsyncThunk(
  "fetchItemsDataForSample",
  async () => {
    let response: any;
    await GET(`/v1/worker/order-items`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const fetchProcessesData = createAsyncThunk(
  "fetchProcessesDataForSample",
  async () => {
    let response: any;
    await GET(`/v1/worker/order-processes`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const newOrderSliceSlice = createSlice({
  name: "newOrderSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPartiesData.pending, (state, action: any) => {
      state.parties = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPartiesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.parties = action.payload.data.data;
        state.error = null;
      } else {
        state.parties = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchPartiesData.rejected, (state, action: any) => {
      state.parties = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });

    builder.addCase(fetchItemsData.pending, (state, action: any) => {
      state.items = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchItemsData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.items = action.payload.data.data;
        state.error = null;
      } else {
        state.items = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchItemsData.rejected, (state, action: any) => {
      state.items = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });

    builder.addCase(fetchProcessesData.pending, (state, action: any) => {
      state.processes = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchProcessesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.processes = action.payload.data.data;
        state.error = null;
      } else {
        state.processes = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchProcessesData.rejected, (state, action: any) => {
      state.processes = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const getParties = (state: RootState) => state.newSample.parties;

export const getItems = (state: RootState) => state.newSample.items;

export const getProcesses = (state: RootState) => state.newSample.processes;

export default newOrderSliceSlice.reducer;
